import React, { useState } from "react";
import {
    Row,
    Col,
    Card,
    Input,
    Button,
    Typography,
    Divider,
    message,
    Space,
} from "antd";
import {
    QrcodeOutlined,
    DownloadOutlined,
    LinkOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const QRCodeGenerator = () => {
    const [url, setUrl] = useState("");
    const [qrImage, setQrImage] = useState("");
    const [loading, setLoading] = useState(false);

    const generateQR = async () => {
        if (!url) {
            message.error("Please enter a valid URL");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(
                `${API_BASE_URL}/api/generate-qr?url=${encodeURIComponent(url)}`
            );
            if (!response.ok) {
                throw new Error("Failed");
            }

            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);
            setQrImage(imageUrl);
        } catch (error) {
            message.error("Failed to generate QR Code");
        } finally {
            setLoading(false);
        }
    };

    const downloadPNG = () => {
        const link = document.createElement("a");
        link.href = qrImage;
        link.download = "qrcode.png";
        link.click();
    };

    const downloadPDF = () => {
        const pdfWindow = window.open("");
        pdfWindow.document.write(`
      <html>
        <head><title>QR Code</title></head>
        <body style="text-align:center;font-family:sans-serif;">
          <h2>QR Code</h2>
          <img src="${qrImage}" />
        </body>
      </html>
    `);
        pdfWindow.print();
    };

    return (
        <div className="qr-generator">
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={24}>
                    <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                        title={
                            <Space>
                                <QrcodeOutlined />
                                <span>QR Code Generator</span>
                            </Space>
                        }
                        extra={
                            <Text type="secondary">
                                Generate & Download QR Codes Instantly
                            </Text>
                        }
                    >
                        {/* Input Section */}
                        <Row gutter={16} align="middle">
                            <Col xs={24} md={18}>
                                <Input
                                    size="large"
                                    prefix={<LinkOutlined />}
                                    placeholder="https://example.com"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                />
                            </Col>
                            <Col xs={24} md={6}>
                                <Button
                                    type="primary"
                                    size="large"
                                    block
                                    loading={loading}
                                    onClick={generateQR}
                                    icon={<QrcodeOutlined />}
                                >
                                    Generate
                                </Button>
                            </Col>
                        </Row>

                        {qrImage && (
                            <>
                                <Divider />

                                {/* QR Preview Section */}
                                <Row justify="center">
                                    <Col>
                                        <Card
                                            bordered
                                            style={{
                                                textAlign: "center",
                                                padding: 20,
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                                borderRadius: 12,
                                            }}
                                        >
                                            <Title level={5}>QR Preview</Title>
                                            <img
                                                src={qrImage}
                                                alt="QR Code"
                                                style={{ width: 200 }}
                                            />
                                        </Card>
                                    </Col>
                                </Row>

                                {/* Download Buttons */}
                                <Row justify="center" style={{ marginTop: 20 }}>
                                    <Space>
                                        <Button
                                            icon={<DownloadOutlined />}
                                            onClick={downloadPNG}
                                        >
                                            Download PNG
                                        </Button>

                                        <Button
                                            icon={<DownloadOutlined />}
                                            type="primary"
                                            onClick={downloadPDF}
                                        >
                                            Download PDF
                                        </Button>
                                    </Space>
                                </Row>
                            </>
                        )}
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default QRCodeGenerator;